import { useEffect } from 'react';

export const usePageTitle = (title: string, description?: string) => {
  useEffect(() => {
    const previousTitle = document.title;
    document.title = `${title} | NomadicAI`;

    // Update meta description if provided
    if (description) {
      let metaDescription = document.querySelector('meta[name="description"]');
      if (!metaDescription) {
        metaDescription = document.createElement('meta');
        metaDescription.setAttribute('name', 'description');
        document.head.appendChild(metaDescription);
      }
      metaDescription.setAttribute('content', description);
    }

    // Cleanup function to restore previous title
    return () => {
      document.title = previousTitle;
    };
  }, [title, description]);
};